import React from "react";
/** @jsxImportSource @emotion/react */
import {css} from "@emotion/react";
import {useTheme} from "@emotion/react";
import {useLogout} from "../../../utils/Hooks";
import {ROUND_BOX} from "../../_presentational/buttons";

const LogoutButton = () => {
    const {doLogout} = useLogout();

    // css style
    const {css} = useComponentStyle();

    return (
        <div onClick={doLogout} style={{height: "100%"}}>
            <ROUND_BOX css={css.logout_button_css}>로그아웃</ROUND_BOX>
        </div>
    );
};

export default LogoutButton;

export const useComponentStyle = () => {
    const theme = useTheme();
    return {
        css: {
            logout_button_css: css({
                padding: ".8em 0",
                width: "6em",
                height: "100%",
                border: `2px solid ${theme.colors.lg3}`,
                fontSize: theme.font_size.f15,
                fontWeight: "700",
                color: theme.colors.dg1,
                cursor: "pointer",
                transition: "all .2s",
                "@media (max-width: 320px)": {
                    fontSize: theme.font_size.f14,
                    width: "5.5em",
                },
            }),
        },
    };
};
